<template>
  <div class="wizard">
    <component
      v-if="!done"
      :is="currentStep"
      ref="step"
      :context="stepContext"
      @back="back"
      @done="next"
    />
    <!--<congrats v-if="done" />-->
    <v-overlay v-if="processing">
      <v-progress-circular color="primary" indeterminate />
    </v-overlay>
  </div>
</template>

<script>
import BusinessDetailsStep from "./steps/BusinessDetailsStep";
import LoyaltyCoreStep from "./steps/LoyaltyCoreStep";
import LoyaltyPromotionStep from "./steps/LoyaltyPromotionStep";
import Congrats from "./Congrats";
import axios from "axios";
import uuid from "uuid";

export default {
  components: {
    BusinessDetailsStep,
    LoyaltyCoreStep,
    LoyaltyPromotionStep,
    Congrats
  },
  data() {
    return {
      steps: ["BusinessDetailsStep", "LoyaltyCoreStep", "LoyaltyPromotionStep"],
      currentStepIndex: 1,
      data: {},
      done: false,
      processing: false
    };
  },
  created() {
    this.id = uuid();
    this.$ga.page("Wizard Step #1");
  },
  watch: {
    currentStepIndex(currentStepIndex) {
      this.$ga.page(`Wizard Step #${currentStepIndex}`);
    },
    done(done) {
      done && this.$ga.page("Wizard Congratulations");
    }
  },
  computed: {
    currentStep() {
      return this.steps[this.currentStepIndex - 1];
    },
    stepContext() {
      return {
        currentStep: this.currentStepIndex,
        totalSteps: this.steps.length,
        firstStep: this.currentStepIndex === 1,
        lastStep: this.currentStepIndex === this.steps.length,
        submittedData: this.data[this.currentStepIndex]
      };
    }
  },
  methods: {
    back() {
      if (!this.stepContext.firstStep) this.currentStepIndex--;
      else this.$router.replace("/");
    },
    async next(data) {
      this.data[this.currentStepIndex] = data;

      if (this.stepContext.lastStep) {
        this.processing = true;
        // Submit form and wait for ack
        await this.submitForm();
        this.processing = false;
        this.done = true;
      } else this.currentStepIndex++;
    },

    submitForm() {

      let $emailData = '<b>Firma İsmi: </b>'+ this.data[1].general.businessName + '<br>' +
              '<b>İlgili Kişi: </b>' + this.data[1].general.contactName + '<br>' +
              '<b>EPosta: </b>' + this.data[1].general.email + '<br>' +
              '<b>Telefon: </b>' + this.data[1].general.phone + '<br>' +
              '<b>Lokasyon: </b>' + this.data[1].general.numberOfLocations + '<br>' +
              '<b>POS: </b>' + this.data[1].general.POS + '<br>' +
              '<b>Loyalty var mı?: </b>' + this.data[1].existingLoyaltyProgram + '<br>' +
              '<b>---</b><br>' +
              '<b>Loyalty: </b>' + this.data[2].earnAndRedeem.value + '<br>' +
              '<b>Accumulation: </b>' + this.data[2].earnAndRedeem.accumulation + '<br>' +
              '<b>Punch: </b>' + JSON.stringify(this.data[2].earnAndRedeem.punch) + '<br>' +
              '<b>Katılım Ödülü: </b>' + this.data[2].joiningGiftDiscount + '<br>' +
              '<b>Doğum Günü: </b>' + this.data[2].birthdayGiftDiscount + '<br>' +
              '<b>---</b><br>' +
              '<b>Günler: </b>' + JSON.stringify(this.data[3].promoteDaysAndTimes.days) + '<br>' +
              '<b>Zaman: </b>' + JSON.stringify(this.data[3].promoteDaysAndTimes.times.value) + '<br>' +
              '<b>Saatler: </b>' + JSON.stringify(this.data[3].promoteDaysAndTimes.times.hours) + '<br>' +
              '<b>MarketingAuto: </b>' + this.data[3].marketingAutomation + '<br>' +
              '<b>SMS - Email Gönder: </b>' + this.data[3].sendDiscountAlerts ;

      axios.post('https://bonobo.com.tr/postman/mailler.php', $emailData)
          .then(response => {
            console.log('success', response.data);
            window.location.href = 'https://bonobo.com.tr/tr/como-basic-form-tebrikler/';
          })
          .catch(error => {
            console.log(error.response);
            window.location.href = 'https://bonobo.com.tr/tr/como-basic-form-tebrikler/';
          });

    }
  }
};
</script>

<style scoped>
.wizard {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
